import styled from 'styled-components'
import TemplateLink from 'components/navigation/TemplateLink'
import device from 'utilities/device'

export const StyledTable = styled.table`
  border-spacing: 0;
  border-radius: 5px 5px 0px 0px;
  width: 100%;
  word-break: break-word;
  border-collapse: collapse;
  color: ${({ theme }) => theme.text};
  a:hover {
    text-decoration: underline;
  }
  th,
  td {
    &:nth-child(1) {
      /* Title */
      width: 12%;
    }
    &:nth-child(2) {
      /* Owners */
      width: 12%;
    }
    &:nth-child(3) {
      /* Descrip */
      width: 30%;
    }
    &:nth-child(4) {
      /* Topic */
      width: 12%;
    }
    &:nth-child(5) {
      /* Filter 1 */
      width: 12%;
    }
    &:nth-child(6) {
      /* Filter 2 */
      width: 12%;
    }
    &:nth-child(7) {
      /* Data access */
      width: 10%;
    }
  }
`
export const StyledTh = styled.th`
  color: ${({ theme }) => theme.background};
  background-color: ${({ theme }) => theme.primary};
  padding: 0.5rem;
  text-align: left;
  border-right: 1px solid ${({ theme }) => theme.neutral2};
  &:first-of-type {
    border-radius: 5px 0px 0px 0px;
  }
  &:last-of-type {
    border-radius: 0px 5px 0px 0px;
    border-right: 0px solid white;
  }
  vertical-align: top;
  hyphens: auto;
`
export const StyledTd = styled.td`
  padding: 0.5rem;
  border: 1px solid ${({ theme }) => theme.neutral2};
  vertical-align: top;
`
export const StyledTbody = styled.tbody`
  background-color: ${({ theme }) => theme.backgroundAlternate};
  ${({ theme }) => theme.textStyleMedParagraph};
`
export const StyledThead = styled.thead`
  border-radius: 5px;
  ${({ theme }) => theme.textStyleMedParagraphBold};
`
export const SortIcon = styled.span`
  position: absolute;
  right: 0;
  top: -4px;
`
export const FlexContainer = styled.div`
  vertical-align: top;
  height: 100%;
  position: relative;
  padding-right: 40px;
  display: flex;
  flex-direction: column;
`
export const StyledTemplateLink = styled(TemplateLink)`
  color: ${({ theme }) => theme.links};
`
export const Pagination = styled.div`
  ${({ theme }) => theme.textStyleMedParagraph};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1rem;
  color: ${({ theme }) => theme.text};
  @media ${device.tablet} {
    flex-direction: column;
  }
`
export const PageLengthSelect = styled.select`
  border-radius: 5px;
  padding: 5px 10px;
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.neutral2};
  background-color: ${({ theme }) => theme.backgroundAlternate};
`
export const BottomRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media ${device.tablet} {
    justify-content: space-between;
    &:last-child {
      margin-top: 0.75rem;
      padding-top: 0.75rem;
      border-top: 1px solid ${({ theme }) => theme.neutral2};
    }
  }
`
export const NavigateButton = styled.button`
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.neutral2};
  background-color: ${({ theme }) => theme.backgroundAlternate};
  padding: 5px 10px;
  color: ${({ theme }) => theme.text};

  &:disabled {
    color: ${({ theme }) => theme.neutral2};
  }
`
export const NavButtons = styled.div`
  display: flex;
  flex-direction: row;
`
export const PageInfo = styled.span`
  margin-right: 0.5rem;
`
export const NumResults = styled.p`
  margin-left: 1rem;
`
